import React from 'react';
import { connect } from 'react-redux';
import { compose, withStateHandlers, renderNothing, branch } from 'recompose';

import withPagination from '../../PaginatedItems/withPagination';
import GeoSearchRow from './GeoSearchRow';
import { Endpoints } from '../../../lib/LeanLinkService';
import debounceProp from '../../../lib/debounceProp';
import { geoCodesByIds } from '../../../entities/GeoCode/selectors';

function GeoSearchRowContainerPublic({ ...props }) {
  return (
    <div>
      <GeoSearchRow
        {...props}
      />
    </div>
  );
}

const withGeoCodes = connect(
  (state, { ids }) => ({
    geoCodes: geoCodesByIds(state, ids),
  }),
);

export default compose(
  branch(
    ({ index, maxAllowedGeoSearches }) => {
      if (maxAllowedGeoSearches === undefined) {
        return false;
      }
      return index >= (maxAllowedGeoSearches);
    },
    renderNothing,
  ),
  withStateHandlers({
    url: Endpoints.publicAreas(),
    inputValue: undefined,
  }, {
    onInputChange: () => (inputValue) => ({
      url: Endpoints.publicAreas({
        q: inputValue,
      }),
    }),
  }),
  debounceProp('url'),
  withPagination(),
  withGeoCodes,
)(GeoSearchRowContainerPublic);
